
export const  lst_pendiente_pagos = [ {id:1, nombre:"Pendiente"}, {id:2, nombre:"Cancelado"} ]


export const PENDIENTE = 1;
export const CANCELADO = 2;


